import { useState } from 'react'
import { Clock, Pin, Trash2 } from 'lucide-react'
import { Interactive, Popover } from '@highlight/ui'
import { useReminderActions, type ReminderItem } from '../../../hooks/use-reminders'
import { TodoActionButton, TodoActions } from '../../cells/todo-actions'
import { ReminderDatePicker } from '../date-picker'
import { isPinnedReminder } from '../utils/pinned'

const TODO_ROW_TRIGGER = 'todo row'

/** A reminder's moves on the To-dos Home: pin, due date and delete. */
export function ReminderTodoActions({ item, onSaving }: { item: ReminderItem; onSaving: () => void }) {
  const { setPinned, updateItem, deleteItem } = useReminderActions()
  const [dueOpen, setDueOpen] = useState(false)
  const pinned = isPinnedReminder(item)

  return (
    <TodoActions open={dueOpen}>
      <TodoActionButton
        label={pinned ? 'Unpin' : 'Pin'}
        aria-pressed={pinned}
        onClick={() => {
          setPinned(item.id, !pinned, { trigger: TODO_ROW_TRIGGER })
          onSaving()
        }}
      >
        <Pin className={pinned ? 'fill-current' : undefined} />
      </TodoActionButton>
      <Popover open={dueOpen} onOpenChange={setDueOpen}>
        <Popover.Trigger render={<span className="flex" />} nativeButton={false}>
          <TodoActionButton label="Set due date">
            <Clock />
          </TodoActionButton>
        </Popover.Trigger>
        <Popover.Content
          side="bottom"
          align="end"
          sideOffset={8}
          initialFocus={false}
          positionerClassName="z-[80]"
          className="w-[320px] p-1"
        >
          <Interactive>
            <ReminderDatePicker
              value={item.scheduledAt}
              onChange={(date) => {
                updateItem(item.id, item.title, date, { trigger: TODO_ROW_TRIGGER })
                onSaving()
              }}
            />
          </Interactive>
        </Popover.Content>
      </Popover>
      <TodoActionButton label="Delete" tone="danger" onClick={() => deleteItem(item.id, { trigger: TODO_ROW_TRIGGER })}>
        <Trash2 />
      </TodoActionButton>
    </TodoActions>
  )
}
